import { MenuItem, TextField } from '@munifocus/ui';
import { useTranslation } from 'react-i18next';

export type InviteLanguage = 'en' | 'fr';

/**
 * Which language an invited account is created in. It decides the language of
 * the welcome (and its set-password link) and of every message after it, so a
 * francophone hire is not mailed in English until they find the setting. An
 * existing account keeps its own language; the API ignores this for it.
 */
export function InviteLanguageField({
  value,
  onChange,
}: {
  value: InviteLanguage;
  onChange: (next: InviteLanguage) => void;
}) {
  const { t } = useTranslation();
  return (
    <TextField
      select
      label={t('gov.admin.inviteLanguage.label')}
      value={value}
      onChange={(e) => onChange(e.target.value === 'fr' ? 'fr' : 'en')}
      helperText={t('gov.admin.inviteLanguage.help')}
      fullWidth
    >
      <MenuItem value="en">{t('gov.admin.inviteLanguage.en')}</MenuItem>
      <MenuItem value="fr">{t('gov.admin.inviteLanguage.fr')}</MenuItem>
    </TextField>
  );
}
